var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5AC37",
    d: "M12 0c6.628 0 12 5.373 12 12 0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFD",
    d: "M12.442 12.847h4.56c.097 0 .143 0 .15-.127a8.73 8.73 0 0 0 0-1.395c0-.09-.044-.127-.142-.127H7.935c-.112 0-.143.037-.143.142v1.335c0 .172 0 .172.18.172h4.47Zm4.201-3.21a.146.146 0 0 0 0-.104 2.967 2.967 0 0 0-.27-.473 3.827 3.827 0 0 0-.556-.697 1.84 1.84 0 0 0-.345-.338 5.391 5.391 0 0 0-2.25-1.14 5.593 5.593 0 0 0-1.275-.135H7.919c-.112 0-.127.045-.127.143v2.662c0 .112 0 .142.142.142h8.655s.075-.015.09-.06h-.036Zm0 4.77a1.755 1.755 0 0 0-.383 0H7.943c-.113 0-.15 0-.15.15v2.603c0 .12 0 .15.15.15h3.84c.183.014.367.002.547-.037a5.713 5.713 0 0 0 1.628-.36 3.02 3.02 0 0 0 .547-.255h.052a4.872 4.872 0 0 0 2.093-2.107s.052-.113-.007-.143ZM6.285 18.66v-4.147c0-.098 0-.113-.12-.113H4.538c-.09 0-.128 0-.128-.12v-1.425h1.74c.097 0 .135 0 .135-.127v-1.41c0-.09 0-.112-.12-.112H4.538c-.09 0-.128 0-.128-.12v-1.32c0-.083 0-.105.12-.105h1.613c.112 0 .142 0 .142-.142V5.476c0-.12 0-.15.15-.15h5.625c.408.016.814.061 1.215.135a7.33 7.33 0 0 1 2.348.87c.481.283.925.626 1.32 1.02.296.308.564.642.802.997.236.36.432.746.586 1.148a.196.196 0 0 0 .224.158h1.342c.173 0 .173 0 .18.165v1.23c0 .12-.045.15-.165.15h-1.035c-.105 0-.135 0-.128.135.041.457.041.915 0 1.372 0 .128 0 .143.143.143h1.184c.053.067 0 .135 0 .203.008.087.008.175 0 .262v.908c0 .127-.037.165-.15.165H18.51a.188.188 0 0 0-.218.142 5.997 5.997 0 0 1-1.575 2.295c-.255.23-.523.446-.802.645-.3.173-.593.353-.9.495a8.113 8.113 0 0 1-1.77.563 9.227 9.227 0 0 1-1.756.142H6.283v-.008l.002-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.b618e7f05d9b26fc9b5a0429f517dfad.svg";
export { ForwardRef as ReactComponent };